<template>
	<div class="order-status">

		<div class="order-status__content">
			<div class="order-status__video">
				<video v-if="isMD" autoplay muted loop playsinline class="anim-fade-in">
					<source src="@/assets/home/intro/Schastye_1980х1100.mp4" type="video/mp4">
				</video>
				<video v-else autoplay muted loop playsinline class="anim-fade-in">
					<source src="@/assets/home/intro/Schastye_640х1280.mp4" type="video/mp4">
				</video>
			</div>

			<div class="order-status__text">
				<v-container>
					<v-row>
						<v-col cols="12" class="text-center">

							<template v-if="order">
								<div class="mt-15">
									<svgicon name="logo" original/>
									<h1 class="mt-8 d-flex align-center justify-center"><span class="dot white"></span>{{order.ID_1C}}<span
											class="dot white"></span></h1>
									<p>номер заказа</p>
								</div>

								<template v-if="isPayed">
									<h1 class="mt-8">Спасибо!</h1>
<!--									<p class="mt-4">Мы уже готовим ваши прекрасные конфеты!</p>-->

<!--									<btn-primary :to="{ name: 'home' }" class="mx-auto mt-10" label="На главную"/>-->
								</template>
								<template v-else>
									<h1 class="mt-8">Не получилось...</h1>
									<p class="mt-4">Похоже, что оплата не прошла. Пожалуйста, попробуйте еще раз.</p>

									<btn-link :to="{ name: 'order', params:{id: order.ID} }"
											  class="mx-auto mt-10"
											  label="Повторить"/>
								</template>
							</template>
							<template v-else>
								<div class="mt-15">
									<svgicon name="logo" original/>
								</div>

								<h1 class="mt-8">Заказ не найден...</h1>
								<p class="mt-4">К сожалению, мы не смогли найти данный заказ.<br/>Если у Вас не получается оформить заказ или произвести оплату - пожалуйста, свяжитесь с нами.</p>

								<btn-link :to="{ name: 'home-contacts' }" class="mx-auto mt-10" label="Связаться с магазином"/>
							</template>

						</v-col>
					</v-row>
				</v-container>
			</div>
		</div>

	</div>
</template>

<script>
	import BtnLink from '@/components/btn-link';
	import vp from "@/mixins/vp";
  import BtnPrimary from "@/components/btn-primary.vue";
  import metrika from "@/utils/metrika";

	export default {
		name: "order-status",
		mixins: [vp],
		components: {
      BtnPrimary,
			BtnLink
		},
		data() {
			return {}
		},
		computed: {
			order() {
				return this.$store.state.page?.OrderStatusController?.order;
			},
			isPayed() {
				return this.order.PAYED === "Y";
			},
            page() {
                return this.$store.state.page.OrderStatusController;
            },
            /*labelRetryText() {
                return this.page.texts?.ORDER_RETRY?.NAME;
            },
            labelHomeText() {
                return this.page.texts?.ORDER_HOME_PAGE?.NAME;
            },*/
			/*texts() {
				return this.page.texts || {};
			},
			ORDER_NUMBER() {
				return this.texts?.ORDER_NUMBER?.NAME;
			},
			ORDER_THANK() {
				return this.texts?.ORDER_THANK?.NAME;
			},
			ORDER_WE_ARE_ALREADY() {
				return this.texts?.ORDER_NUMBER?.NAME;
			}*/
		},
    mounted() {
      if (this.isPayed) {
        metrika.reachGoal('paidOrder');
      }
    }
  }
</script>

<style lang="scss">
	.order-status {

		&__content {
			position: relative;
			height: 640px;
			display: flex;
			align-items: center;
			justify-content: center;
			background: $black;
		}

		&__video {
			//width: 320px;
			//margin: 0 auto;
			position: absolute;
			width: 100%;
			height: 100%;
			opacity: 0.4;

			video {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				object-fit: cover;
				//mix-blend-mode: lighten;
				//animation: fade-in 2s forwards;
			}
		}

		&__text {
			position: relative;
			z-index: 1;

			p, span {
				color: $white;
			}

			svg {
				width: 128px;
				height: 128px;
			}

			.btn-link {
				color: $white !important;
			}
		}
	}
</style>
